import { render } from "./ProjectPage.vue?vue&type=template&id=44f3ebd0"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"

import "./ProjectPage.vue?vue&type=style&index=0&id=44f3ebd0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__